import React from "react";
import { Button } from "@material-ui/core";

import Popup from "../popup";
import { ApiCredentialStyle } from "./style";

function AddEditApiCredential(props) {
  const classes = ApiCredentialStyle();
  return (
    <div className={classes.ApiCredentialWrapper}>
      <Button
        className="orange-btn primary-btn"
        color="inherit"
        disableElevation
        underlinenone="true"
        onClick={props.handleClickOpen}
      >
        + Add Credential
      </Button>

      <Popup
        formik={props.formik}
        handleClose={props.handleClose}
        open={props.open}
        isEdit={props.isEdit}
        error={props.error}
      />
    </div>
  );
}

export default AddEditApiCredential;
